import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAlert,{staticClass:"mt-8",attrs:{"type":"error","transition":"slide-y-reverse-transition","value":_vm.show}},_vm._l((_vm.errors),function(error,i){return _c('div',{key:i},[_vm._v(_vm._s(error))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }